import React, { useState, useEffect } from "react";

import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { NotificationManager } from "react-notifications";

import KeyboardArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";
import JDate from "jalali-date";

import styles from "../../../styles/management.module.css";
import { useNavigate } from "react-router";
import reducer from "../../store";
import { AutoSizer, Column, Table } from "react-virtualized";
import { FcSearch } from "react-icons/fc";
import Spinner from "../../spinner";
import Conf from "../../../conf";

let user;

const Devices = () => {
    const history = useNavigate();

    const { UserID } = useParams();

    const users = Object.values(useSelector((state) => state.users.items));

    const [devices, set_devices] = useState(Object.values(reducer.getState().devices.items));
    const [name, setName] = useState("");
    const [userDevices, setUserDevices] = useState([]);
    const [search, set_search] = useState("");
    const [wait, set_wait] = useState(false);

    const update = () => {
        set_wait(true);
        fetch(`${Conf.server_address}/devices?userId=${user.id}`, {
            method: "GET",
            headers: { "Content-Type": "application/json", accept: "application/json" },
            credentials: "include",
            cache: "no-cache",
        })
            .then((response) => {
                return response.json();
            })
            .then((response) => setUserDevices(response))
            .finally(() => set_wait(false));
    };

    useEffect(() => {
        if (users.length === 0) history("/management/users");
        else {
            const UserID_ = parseInt(UserID);
            user = users.find((Row) => Row.id === UserID_);
            setName(user.name);

            update();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (search !== "")
            set_devices(
                Object.values(reducer.getState().devices.items).filter((x) => (x.phone && x.phone.includes(search)) || (x.name && x.name.includes(search)) || x.uniqueId.includes(search))
            );
        else set_devices(Object.values(reducer.getState().devices.items));
    }, [search]);

    const onClick = (device, userDevices) => {
        let selected = userDevices.filter((Row) => Row.id === device.id).length !== 0;
        if (selected) {
            let data = {
                userId: user.id,
                deviceId: device.id,
            };
            fetch(`${Conf.server_address}/permissions`, {
                method: "DELETE",
                headers: { "Content-Type": "application/json", accept: "*/*" },
                credentials: "include",
                body: JSON.stringify(data),
            }).then((response) => {
                if (response.status !== 204) {
                    NotificationManager.error("خطا در بروز رسانی", "", 2500);
                } else {
                    NotificationManager.success("خودرو با موفقیت حذف شد", "", 2500);
                    update();
                }
            });
        } else {
            let data = {
                userId: user.id,
                deviceId: device.id,
            };
            fetch(`${Conf.server_address}/permissions`, {
                method: "POST",
                headers: { "Content-Type": "application/json", accept: "*/*" },
                credentials: "include",
                body: JSON.stringify(data),
            }).then((response) => {
                if (response.status !== 204) {
                    NotificationManager.error("خطا در بروز رسانی", "", 2500);
                } else {
                    NotificationManager.success("خودرو با موفقیت اضافه شد", "", 2500);
                    update();
                }
            });
        }
    };

    return (
        <div className={styles.main}>
            <div className={styles.header}>
                <div className={styles.headerRight}>
                    کاربران{" > "}
                    {name}
                    {" > "}
                    دستگاه ها
                </div>
                <div className={styles.headerLeft} onClick={() => history(`/management/users/edit/${user.id}`)}>
                    <KeyboardArrowLeftIcon className={styles.exitIcon} />
                    بازگشت
                </div>
            </div>
            <div className={styles.body}>
                <div className={styles.bodyTop}>
                    <div className={styles.bodyTopText}>تعداد کل دستگاه ها :{devices.length}</div>
                    <span className={styles.GlobalFilterHolder}>
                        <input className={styles.GlobalFilter} value={search} onChange={(e) => set_search(e.target.value)} />
                        <FcSearch size={20} />
                    </span>
                </div>
                <div className={styles.contents}>
                    <Spinner wait={wait} center={true} color={"#263c99"}>
                        <div style={{ width: "100%", height: "100%", minWidth: 900 }}>
                            <AutoSizer>
                                {({ height, width }) => (
                                    <Table
                                        rowClassName={({ index: i }) => {
                                            return i > -1 && userDevices.length !== 0
                                                ? userDevices.filter((Row) => Row.id === devices[i].id).length !== 0
                                                    ? "have_device"
                                                    : i % 2 === 0
                                                    ? "table_ch_env"
                                                    : ""
                                                : i % 2 === 0
                                                ? "table_ch_env"
                                                : "";
                                        }}
                                        rowCount={devices.length}
                                        rowGetter={({ index }) => devices[index]}
                                        width={width}
                                        height={height}
                                        headerHeight={20}
                                        rowHeight={50}
                                        onRowClick={({ rowData }) => onClick(rowData, userDevices)}
                                    >
                                        <Column
                                            dataKey={"0"}
                                            flexGrow={1}
                                            width={140}
                                            minWidth={140}
                                            maxWidth={140}
                                            label="نام"
                                            height={50}
                                            cellRenderer={({ rowIndex, rowData }) => rowData.name}
                                        />
                                        <Column
                                            dataKey={"0"}
                                            flexGrow={1}
                                            width={140}
                                            minWidth={140}
                                            maxWidth={140}
                                            label="ID دستگاه"
                                            height={50}
                                            cellRenderer={({ rowIndex, rowData }) => rowData.uniqueId}
                                        />
                                        <Column
                                            dataKey={"0"}
                                            flexGrow={1}
                                            label="شماره دستگاه"
                                            height={50}
                                            cellRenderer={({ rowIndex, rowData }) => (rowData.phone === "" ? "----" : rowData.phone)}
                                            width={140}
                                            minWidth={140}
                                            maxWidth={140}
                                        />
                                        <Column
                                            dataKey={"0"}
                                            flexGrow={1}
                                            label="تاریخ فعال سازی"
                                            height={50}
                                            cellRenderer={({ rowIndex, rowData }) =>
                                                rowData.attributes.createtionDate ? new JDate(new Date(rowData.attributes.createtionDate)).format("dddd DD MMMM YYYY") : "----"
                                            }
                                            width={140}
                                            minWidth={140}
                                            maxWidth={140}
                                        />
                                        <Column
                                            dataKey={"0"}
                                            flexGrow={1}
                                            label="آخرین فعالیت"
                                            height={50}
                                            width={140}
                                            minWidth={140}
                                            maxWidth={140}
                                            cellRenderer={({ rowIndex, rowData }) => (rowData.lastUpdate ? new JDate(new Date(rowData.lastUpdate)).format("dddd DD MMMM YYYY") : "----")}
                                        />
                                        <Column
                                            dataKey={"0"}
                                            label="پایان اشتراک"
                                            height={50}
                                            cellRenderer={({ rowIndex, rowData }) =>
                                                rowData.attributes.subscriptionEndDate ? new JDate(new Date(rowData.attributes.subscriptionEndDate)).format("dddd DD MMMM YYYY") : "----"
                                            }
                                            flexGrow={1}
                                            width={140}
                                            minWidth={140}
                                            maxWidth={140}
                                        />
                                    </Table>
                                )}
                            </AutoSizer>
                        </div>
                    </Spinner>
                </div>
            </div>
        </div>
    );
};

export default Devices;
